import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LoginComponent } from '../components';
import { HttpClient } from '@angular/common/http';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { jwtDecode } from 'jwt-decode';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  isRefreshingToken: boolean = false;
  isFirstNavigation = true;

  constructor(private dialog: MatDialog, private http: HttpClient, private router: Router) {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      if (!this.isFirstNavigation) {
        this.refreshTokenIfNeeded();
      }
      this.isFirstNavigation = false;
    });
  }

  setToken(authToken: string): void {
    const token = {
      access_token: authToken,
    };
    localStorage.setItem('token', JSON.stringify(token));
  }

  isTokenValid(): boolean {
    const token = JSON.parse(localStorage.getItem('token'));
    if (!token || !token.access_token) return false;

    try {
      const decoded: any = jwtDecode(token.access_token);
      const currentTime = Math.floor(Date.now() / 1000);
      return decoded.exp > currentTime;
    } catch (error) {
      console.error('Invalid token:', error);
      return false;
    }
  }

  refreshTokenIfNeeded(): void {
    if (!this.isRefreshingToken && !this.isTokenValid()) {
      this.refreshToken();
    }
  }

  refreshToken(url: any = null, callback?: () => void): any {
    if (this.isRefreshingToken) {
      return
    }
    this.isRefreshingToken = true;
    const refreshToken = localStorage.getItem("refreshtoken");
    this.http.post<any>('https://yeh7u2wxha.execute-api.ap-southeast-2.amazonaws.com/refresh', { refresh_token: refreshToken }).subscribe(
      (response) => {
        const newAccessToken = response.access_token;
        if (url) {
          this.router.navigateByUrl(url);
        }
        this.setToken(newAccessToken);
        this.isRefreshingToken = false;
        if (callback) {
          callback();
        }
      },
      (error) => {
        console.error('Error refreshing token:', error);
        this.router.navigate(['/login']);
      },
      () => {
        this.isRefreshingToken = false;
      }
    );
  }
}
